import React, { useEffect, useState } from 'react';
import { Avatar } from 'antd';
import toast from 'react-hot-toast';
import { userService, IBlockedUser } from '../../../services/user.service';

const FALLBACK_AVATAR = '/default-avatar.svg';

const BlockList: React.FC = () => {
  const [list, setList] = useState<IBlockedUser[] | undefined>(undefined);
  const [busyId, setBusyId] = useState<string | null>(null);

  const load = async () => {
    try {
      const data = await userService.getBlockedUsers();
      setList(data || []);
    } catch {
      setList([]);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleUnblock = async (userId: string) => {
    if (busyId) return;
    setBusyId(userId);
    try {
      await userService.unblockUser(userId);
      toast.success('Đã bỏ chặn');
      setList((prev) => (prev || []).filter((u) => u.userId !== userId));
    } catch {
      toast.error('Bỏ chặn không thành công');
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="ui-card p-4 rounded-md">
      <h3 className="ui-heading font-bold text-lg">Danh sách đã chặn</h3>
      <p className="ui-muted text-sm mt-1">
        Người bạn đã chặn sẽ không nhắn tin được cho bạn, và hai bên không thấy bài viết
        &amp; trang cá nhân của nhau.
      </p>

      <div className="mt-4 flex flex-col gap-2">
        {list === undefined ? (
          <p className="ui-muted text-sm py-4 text-center">Đang tải…</p>
        ) : list.length === 0 ? (
          <p className="ui-muted text-sm py-6 text-center">Bạn chưa chặn ai.</p>
        ) : (
          list.map((u) => (
            <div
              key={u.userId}
              className="flex items-center gap-3 rounded-lg border border-[#E5E7EB] dark:border-slate-700 p-2.5"
            >
              <Avatar src={u.avatar || FALLBACK_AVATAR} size={40} className="shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="ui-heading font-semibold truncate">{u.fullName}</p>
                <p className="ui-muted text-sm truncate">{u.userName}</p>
              </div>
              <button
                type="button"
                onClick={() => handleUnblock(u.userId)}
                disabled={busyId === u.userId}
                className="shrink-0 rounded-full border border-[#DEE0E6] dark:border-slate-600 px-4 py-1.5 text-sm font-medium ui-text hover:bg-black/[0.03] dark:hover:bg-white/[0.06] transition-colors disabled:opacity-50"
              >
                {busyId === u.userId ? 'Đang xử lý…' : 'Bỏ chặn'}
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlockList;
